var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgLocationGradient = function SvgLocationGradient(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M7.326 3.148a.7.7 0 0 0 .748 1.184l-.748-1.184ZM5.61 6.923A.7.7 0 0 0 4.39 6.24l1.221.684Zm13.69 3.494c0 2.464-1.471 5.074-3.231 7.12-.87 1.011-1.783 1.852-2.563 2.433-.39.292-.737.51-1.018.651-.14.07-.256.118-.347.147a.88.88 0 0 1-.104.027c-.026.005-.038.005-.037.005v1.4c.369 0 .765-.15 1.117-.328a8.547 8.547 0 0 0 1.226-.78c.87-.648 1.857-1.56 2.787-2.642 1.84-2.138 3.57-5.07 3.57-8.033h-1.4ZM12 20.8s-.012 0-.037-.005a.876.876 0 0 1-.105-.027 2.423 2.423 0 0 1-.347-.147 7.18 7.18 0 0 1-1.018-.65c-.78-.582-1.693-1.423-2.563-2.434-1.76-2.046-3.23-4.656-3.23-7.12H3.3c0 2.963 1.729 5.895 3.569 8.033.93 1.082 1.917 1.994 2.787 2.643.434.323.85.59 1.226.779.352.177.748.328 1.118.328v-1.4Zm0-17.6c4.038 0 7.3 3.238 7.3 7.217h1.4C20.7 5.65 16.798 1.8 12 1.8v1.4ZM8.074 4.332A7.324 7.324 0 0 1 12 3.2V1.8a8.724 8.724 0 0 0-4.675 1.348l.748 1.184ZM4.7 10.417c0-1.269.33-2.459.911-3.494L4.39 6.24a8.517 8.517 0 0 0-1.09 4.178h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id2, ")"),
    d: "M15.558 11.021a.7.7 0 1 1-1.346-.386l1.346.386Zm-3.044 1.222a.7.7 0 1 1 .311 1.365l-.31-1.365ZM14.301 10A2.3 2.3 0 0 0 12 7.7V6.3a3.7 3.7 0 0 1 3.7 3.7h-1.4ZM12 7.7A2.3 2.3 0 0 0 9.7 10H8.3A3.7 3.7 0 0 1 12 6.3v1.4ZM9.7 10a2.3 2.3 0 0 0 2.3 2.3v1.4A3.7 3.7 0 0 1 8.3 10h1.4Zm4.51.635c.058-.2.09-.414.09-.635h1.4a3.7 3.7 0 0 1-.143 1.021l-1.346-.386Zm-2.21 1.665c.177 0 .349-.02.513-.057l.311 1.365c-.266.06-.542.092-.824.092v-1.4Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 4,
    x2: 20,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 9,
    x2: 15.001,
    y1: 10,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgLocationGradient;